import { render, staticRenderFns } from "./Callout.vue?vue&type=template&id=27efbf3c&"
import script from "./Callout.vue?vue&type=script&lang=js&"
export * from "./Callout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports